import { render } from "./MerchPage.vue?vue&type=template&id=682d0cba&scoped=true"
import script from "./MerchPage.vue?vue&type=script&lang=js"
export * from "./MerchPage.vue?vue&type=script&lang=js"

import "./MerchPage.vue?vue&type=style&index=0&id=682d0cba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682d0cba"]])

export default __exports__